import firebase from "firebase/app";
import { useMemo } from "react";

import { DbDoc, WithRef } from "models/FbDoc";
import { OrgUserEmailInvite } from "models/OrgUserEmailInvite";
import { OrgUserInvite, OrgUserInviteBase } from "models/OrgUserInvite";

export function inviteIsExpired(invite: OrgUserInviteBase) {
  const { expiresAt } = invite
  return expiresAt > firebase.firestore.Timestamp.now()
}

export function useInviteExpirationFilter(invites?: WithRef<DbDoc<OrgUserInvite>>[]): [invites: WithRef<DbDoc<OrgUserInvite>>[] | null] {
  const nonExpiredInvites = useMemo(() => {
    //TODO: make sure this does not refresh recursively
    //console.log('compute', invites)
    return (
      invites?.filter(invite => inviteIsExpired(invite.data))
    )
  }, [invites])

  return [nonExpiredInvites || null]
}

export function useEmailInviteExpirationFilter(invites?: WithRef<DbDoc<OrgUserEmailInvite>>[]): [invites: WithRef<DbDoc<OrgUserEmailInvite>>[] | null] {
  const nonExpiredInvites = useMemo(() => {
    //TODO: make sure this does not refresh recursively
    //console.log('compute', invites)
    return (
      invites?.filter(invite => inviteIsExpired(invite.data.invite))
    )
  }, [invites])

  return [nonExpiredInvites || null]
}

